/*
 * moonshot-referral.js — invited-friend landing banner.
 *
 * Reads ?ref=CODE on any storefront page, calls the Worker's PUBLIC
 * /referrals/resolve (no auth), and reveals #moonshot-referral-banner with
 * the dynamic friend offer when the code is valid. The ref IS the Shopify
 * discount code; the CTA uses /discount/<code> to apply it natively.
 *
 * Fails closed: any non-valid response or error leaves the banner hidden.
 * Pure UI — no referral logic here.
 */
(function () {
  "use strict";

  var el = document.getElementById("moonshot-referral-banner");
  if (!el) return;

  var ref = new URLSearchParams(window.location.search).get("ref");
  if (!ref) return;

  var base = el.getAttribute("data-worker-base") || "";

  function dollars(cents) {
    if (cents == null || isNaN(cents)) return null;
    var v = cents / 100;
    return v % 1 === 0 ? "$" + v : "$" + v.toFixed(2);
  }

  // Friend's discount — all dynamic from the offer object.
  function friendDiscountText(offer) {
    if (!offer) return "a discount on";
    if (offer.discountType === "percentage") {
      var cap = offer.maxOffCents ? " (up to " + dollars(offer.maxOffCents) + ")" : "";
      return offer.discountValue + "% off" + cap;
    }
    return "$" + offer.discountValue + " off";
  }

  function offerFinePrint(offer) {
    if (!offer) return "";
    var bits = [];
    if (offer.minFriendSpendCents) bits.push("on first orders over " + dollars(offer.minFriendSpendCents));
    if (offer.expiryDays) bits.push("expires in " + offer.expiryDays + " days");
    return bits.length ? bits.join(", ") + "." : "";
  }

  fetch(base + "/referrals/resolve?code=" + encodeURIComponent(ref))
    .then(function (r) {
      return r.ok ? r.json() : null;
    })
    .then(function (data) {
      if (!data || !data.valid) return; // invalid / expired / unavailable → stay hidden

      var name = data.referrerDisplayName || "A friend";
      var offer = data.offer || {};
      var textEl = document.getElementById("moonshot-referral-text");
      var fineEl = document.getElementById("moonshot-referral-fine");
      var cta = document.getElementById("moonshot-referral-cta");

      if (textEl) {
        textEl.textContent =
          name + " wants you in on Moonshot Rips! Grab " +
          friendDiscountText(offer) + " your first stream pack.";
      }
      var fine = offerFinePrint(offer);
      if (fineEl) {
        if (fine) fineEl.textContent = fine;
        else fineEl.hidden = true;
      }
      if (cta) {
        var dc = encodeURIComponent(data.code || ref);
        // ref IS the discount code; /discount/<code> applies it natively and
        // lands the friend on the Moonshot Rips collection (where it redeems).
        cta.setAttribute("href", "/discount/" + dc + "?redirect=/collections/moonshot-rips");
      }
      el.hidden = false;
    })
    .catch(function () {
      /* unavailable → stay hidden */
    });
})();
